// extracted by mini-css-extract-plugin
module.exports = {"view":"_14817"};